import { combineReducers } from "redux";
import authentication from "./AuthReducer";
import appState from "./AppReducer";

const reducers = combineReducers({
  appState,
  authentication
});

export default reducers;
